import { z } from '@harvestiq/zod';

import {
  RmaLrpCommodityNames,
  HiqLrpTypeCodeNames,
} from '@harvestiq/constants';
import { zIsoDate } from '@harvestiq/zod';

export const lrpPlotsRequestSchema = z.object({
  optionType: z.string(),
  strikePrice: z.coerce.number(),
  coveragePrice: z.coerce.number(),
  commodity: z.nativeEnum(RmaLrpCommodityNames),
  commodityType: z.nativeEnum(HiqLrpTypeCodeNames),
  marketingDate: zIsoDate(),
});

export type LrpPlotsRequest = z.infer<typeof lrpPlotsRequestSchema>;

export const lrpPlotsResponseSchema = z.object({
  plotData: z.array(
    z.object({
      x: z.number(),
      y: z.number(),
      'Total Payoff': z.number(),
    })
  ),
  errors: z.array(z.string()).optional(),
});

export type LrpPlotsResponse = z.infer<typeof lrpPlotsResponseSchema>;
